import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Blocks = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  margin: 84px 0 18px;
`;

export const Block = styled.div`
  position: relative;
  flex: 1;
  height: 32px;
  border-radius: 4px;
  margin: 0 1px;
  background: ${({ color }) => color};
`;

export const Label = styled.div`
  position: absolute;
  top: 110%;
  transform: ${({ isFirst }) => (isFirst ? 'unset' : 'translateX(-50%)')};
  font-size: 14px;
  color: #a2a2a2;
`;

export const RightLabel = styled(Label)`
  left: unset;
  transform: none;
  right: 0;
`;

export const StyledScore = styled.div`
  position: absolute;
  top: -62px;
  left: ${({ percentScore }) => `${percentScore}%`};
  transform: ${({ percentScore }) =>
    `translateX(${(percentScore > 5 && percentScore < 95 && '-50%') ||
      (percentScore >= 95 && '-100%') ||
      0})`};
  display: flex;
  flex-direction: column;
  align-items: ${({ percentScore }) =>
    (percentScore <= 5 && 'flex-start') || (percentScore >= 95 && 'flex-end') || 'center'};
  z-index: 2;
  transition: left 0.6s ease;
`;

export const Value = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #333;
`;

export const Description = styled.div`
  font-size: 12px;
  color: #7a7a7a;
  text-transform: uppercase;
  white-space: nowrap;
`;

export const Needle = styled.div`
  width: 4px;
  height: 25px;
  background: #3a4134;
  border-radius: 2px;
`;

export const CreditScoreEmpty = styled.div`
  height: 145px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bbbbbb;
  font-size: 18px;
  margin-top: -32px;
  padding: 0 64px;
  text-align: center;
`;
